import { supabase } from "../supabaseClient";
async function getEventTokenIdFromLaunch(launchIds) {
  let eventTokenLaunchData = await supabase.from("EventTokensLaunchRelations")
      .select("*")
      .in("launchId", launchIds);
      const eventTokens = eventTokenLaunchData?.data?.filter((launch) => launch?.eventTokenId).map((launch) => launch.eventTokenId);

    return eventTokens;
}
async function getLaunchFromEventTokenId(eventId,eventTokenId) {
  let query =  supabase.from("EventTokensLaunchRelations")
      .select("*")
      .eq('eventId', eventId)
      .eq("eventTokenId", eventTokenId)
      const { data, error, count } = await query;
      if (data) return { data, count };
      else throw error;
}
async function getLeadsForTokenPaymentDone(eventId, LeadStatus, chktp1, chkpt2, search,launchIds) {
  const eventTokenIds = await getEventTokenIdFromLaunch(launchIds);
  let query = supabase.from('EventTokenLeadRelations').select('*,groupId(*),eventTokenId(*,tokenId(*),algoId(*)),leadId(*,personId(*),cpId(*),fosId(*),userId(*),LeadStatus!left(*)) , AllotmentPayment(*)', { count: 'exact' })
    .eq('eventId', eventId)
    // .eq('leadId.LeadStatus.status', LeadStatus)
    .eq('checkpt1', chktp1)
    .eq('checkpt2', chkpt2)
    .eq('status', 'active')
    .eq('isPrerequisiteUsed', false)
    .in("eventTokenId", eventTokenIds)
    .order('last_updated_at', { ascending: false });
  console.log(search.includes('VJ'));
  if (search !== null && search !== '') {
    var alphabets = new RegExp('^[a-zA-Z ]*$');
    var numbers = new RegExp('^[0-9]*$');
    if (alphabets.test(search)) {
      search = search.replace(/\s\s+/g, ' ');
      query = query.ilike('leadId.personId.name', `%${search}%`);
    } else if (search.includes('VJ')) {
      const searchLeadId = search.slice(2).split('-').join('');
      const searchTokenNum = search.slice(2);
      query = query.eq('leadId.leadDisplayId', searchLeadId);
      // ! vedashree changes ==> search on token number
      // query = query.or(`leadId.leadDisplayId.eq.${searchLeadId},tokenNumber.ilike.%${searchTokenNum}%`)

    } else if (numbers.test(search)) {
      // const numberSearch = search.slice(2)
      query = query.ilike('tokenNumber', `%${search}%`)
    } else {
      // query = query.eq('displayBandNumber', search);
      query = query.ilike('displayBandNumber', '%' + search + '%');
      // query = query.ilike('tokenNumber', '%' + search + '%')
      // query = query.or(`tokenNumber.ilike.%${search}%,displayBandNumber.ilike.%${search}%`)
    }
  } else {
    // ! vedashree changes for query performance in prod
    query = query.limit(10)
  }
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function getAllLeadsFromTokenLead(eventId, launchIds) {
  const eventTokenIds =   await getEventTokenIdFromLaunch(launchIds);
  let query = supabase.from('EventTokenLeadRelations')
    .select('*,groupId(*),eventTokenId(*,tokenId(*),algoId(*)),leadId(*,personId(*),cpId(*),fosId(*),userId(*),LeadStatus!left(*))', { count: 'exact' })
    .eq('eventId', eventId)
    .eq('isPrerequisiteUsed', false)
    .in("eventTokenId", eventTokenIds)
    .in('leadId.LeadStatus.status', ['Token Payment Complete', 'Checkpoint One Cleared', 'Checkpoint Two Cleared'])
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function getLeadsForFirstPay(eventId, LeadStatus) {

  let query = supabase.from('EventTokenLeadRelations').select('*,groupId(*),eventTokenId(*,tokenId(*),algoId(*)),leadId(*,personId(*),cpId(*),fosId(*),userId(*),LeadStatus!left(*))', { count: 'exact' })
    .eq('eventId', eventId)
    .eq('leadId.LeadStatus.status', LeadStatus)
    .eq('eventTokenId.algoId.algoId', '29b30596-9771-4437-807a-097e201395d3')
    .order('srno', { ascending: true });
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function addQueueLogs(obj) {
  const { data, error } = await supabase
    .from('QueueLogs')
    .insert([{
      ...obj
    }])
  if (data) return data;
  else throw error;
}

async function getLeadDataFromPaymentId(paymentId, LeadStatus, eventId) {
  let query = supabase.from('EventTokenLeadRelations').select('*,groupId(*),eventTokenId(*,tokenId(*),algoId(*)),leadId(*,personId(*),cpId(*),fosId(*),userId(*),LeadStatus!left(*))', { count: 'exact' })
    .eq('paymentId', paymentId)
    .eq('leadId.LeadStatus.status', LeadStatus)
    .eq('eventId', eventId)
    .order('last_updated_at', { ascending: false });

  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function findMaxBandNumber(eventTokenId) {
  console.log(eventTokenId)
  const { data, error } = await supabase.rpc('getmaxbandnumber', {
    pid: eventTokenId,
  });
  if (data) return data;
  else throw error;
}
async function findTotalLeadInGroupForThatEvent(eventId, eventTokenId) {
  let query = supabase.from('EventQueue').select('totalLeadsInGroup').eq('eventId', eventId).eq('eventTokenId', eventTokenId);
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function findTotalLeadInGroup(groupPriority, eventId, eventTokenId) {
  let query = supabase.from('EventQueue').select('totalLeadsInGroup').lt('groupPriority', groupPriority).eq('eventId', eventId).eq('eventTokenId', eventTokenId);
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function updateRunningNumber(updatedRunningNumber, groupId) {
  let query = supabase.from('EventQueue')
    .update({ runningNo: updatedRunningNumber })
    .eq('groupId', groupId);
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
async function updateLeadTokenRelationTable(paymentId, bandNumber, displayBandNumber) {
  let query = supabase.from('EventTokenLeadRelations')
    .update({ bandNumber: bandNumber, displayBandNumber: displayBandNumber })
    .eq('paymentId', paymentId)
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}
// ??Updating all leadsTokenHolders checkpoints
async function updateLeadTokenRelationTableCheckPoints(paymentId, checkpt1, checkpt2, leadId, eventId, launchId) {
  let query = supabase.from('EventTokenLeadRelations')
    .update({ checkpt1: checkpt1, checkpt2: checkpt2, launchId: launchId })
    // .eq('paymentId', paymentId)
    .eq('leadId', leadId)
    .eq('eventId', eventId)
    .eq('status', 'active')
  if (checkpt1 && checkpt2 === false) {
    query = query.eq('checkpt1', false)
  } else if (checkpt1 && checkpt2) {
    query = query.eq('checkpt2', false)
  }
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function updateLeadDisplayBandNumber(paymentId, displayBandNumber) {
  let query = supabase.from('EventTokenLeadRelations')
    .update({ displayBandNumber: displayBandNumber })
    .eq('paymentId', paymentId)
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

async function getLeadDisplayBandNumber(paymentId) {
  let query = supabase.from('EventTokenLeadRelations')
    .select('displayBandNumber')
    .eq('paymentId', paymentId)
  const { data, error, count } = await query;
  if (data) return { data, count };
  else throw error;
}

export {
  getLeadsForTokenPaymentDone, findMaxBandNumber, findTotalLeadInGroupForThatEvent, findTotalLeadInGroup,
  updateLeadTokenRelationTable, updateRunningNumber, getLeadDataFromPaymentId, getLeadsForFirstPay,
  updateLeadTokenRelationTableCheckPoints, updateLeadDisplayBandNumber, getAllLeadsFromTokenLead, getLeadDisplayBandNumber, addQueueLogs,getLaunchFromEventTokenId
}